"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AdminRecruitment_1 = require("./AdminRecruitment");
exports.default = AdminRecruitment_1.AdminRecruitment;
